import React from 'react';
import PublicLayout from '../../components/layout/PublicLayout';

const TermsAndConditionsScreen = () => {
  return (
    <PublicLayout title="Terms and Conditions">
          <p className="effective-date">Effective Date: July 24, 2025</p>

          <p>
            Welcome to <strong>MeetUrExpert</strong> (for users) and <strong>ExpertforProfessional</strong> (for professionals). By accessing or using our platforms, you agree to be bound by these Terms and Conditions. Please read them carefully before using our services.
          </p>

          <h2>1. Overview</h2>
          <ul>
            <li><strong>MeetUrExpert</strong> is a platform for users to discover, connect with, and book appointments with professionals.</li>
            <li><strong>Expert for Professional</strong> is a platform for professionals to manage their profiles, appointments, and interact with users.</li>
          </ul>

          <h2>2. Eligibility</h2>
          <ul>
            <li>You must be at least 18 years old to use either platform.</li>
            <li>Professionals must provide accurate credentials and comply with all applicable laws and regulations.</li>
          </ul>

          <h2>3. Account Registration</h2>
          <ul>
            <li>Users and professionals must provide accurate, current, and complete information during registration and keep their account information updated.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>
          </ul>

          <h2>4. Platform Usage</h2>
          <ul>
            <li><strong>MeetUrExpert:</strong> Users may search for professionals, book appointments, communicate, and provide feedback.</li>
            <li><strong>ExpertforProfessional:</strong> Professionals may manage their availability, accept or reject appointments, communicate with users, and manage their professional profile.</li>
            <li>All interactions must be respectful and lawful. Abuse, harassment, or fraudulent activity is strictly prohibited.</li>
          </ul>

          <h2>5. Services and Content</h2>
          <ul>
            <li>All information provided on the platforms is for informational purposes only and does not constitute professional advice unless explicitly stated by a verified professional.</li>
            <li>We do not guarantee the availability, quality, or outcome of any services provided by professionals.</li>
            <li>Professionals are solely responsible for the services they provide and for complying with all applicable laws and professional standards.</li>
          </ul>

          <h2>6. Payments and Refunds</h2>
          <ul>
            <li>Fees for services are displayed on the platform and must be paid as specified.</li>
            <li>Payments are processed securely through our payment partners.</li>
            <li>Refunds, if applicable, will be handled according to our refund policy.</li>
          </ul>

          <h2>7. Privacy</h2>
          <p>
            Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information.
          </p>

          <h2>8. Intellectual Property</h2>
          <ul>
            <li>All content on both platforms, including text, graphics, logos, and software, is the property of MeetUrExpert/ExpertforProfessional or its licensors and is protected by copyright and other laws.</li>
            <li>You may not copy, modify, distribute, or create derivative works from any content on the platforms without our prior written consent.</li>
          </ul>

          <h2>9. Limitation of Liability</h2>
          <ul>
            <li>Both platforms are provided "as is" and "as available" without warranties of any kind.</li>
            <li>We are not liable for any indirect, incidental, special, or consequential damages arising from your use of the platforms.</li>
            <li>Our total liability to you for any claim arising out of or relating to these Terms or the platforms will not exceed the amount paid by you, if any, for using the platforms.</li>
          </ul>

          <h2>10. Termination</h2>
          <ul>
            <li>We may suspend or terminate your access to either platform at any time for any reason, including violation of these Terms.</li>
            <li>You may stop using the platforms at any time.</li>
          </ul>

          <h2>11. Changes to Terms</h2>
          <p>
            We may update these Terms and Conditions from time to time. We will notify you of significant changes by posting the new terms on this page and updating the effective date.
          </p>

          <h2>12. Contact Us</h2>
          <p>
            If you have any questions about these Terms and Conditions, please contact us at:<br />
            <a href="mailto:meeturexpert@gmail.com">meeturexpert@gmail.com</a>
          </p>
    </PublicLayout>
  );
};

export default TermsAndConditionsScreen;